import EditGeneralAccountPreferencesComponent from './EditGeneralAccountPreferencesContainer';

export default EditGeneralAccountPreferencesComponent;
